
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getFilterData",
      resolverType: "query",
      routePath: "/getFilterData",
      httpMethod: "POST",
    });
  